import { sortBy } from 'lodash/fp';
import { Field, InjectedFormProps } from 'redux-form';

import ReactSelectField from 'dashboard/components/FormControls/ReactSelectField';
import { FormAddListItemProps } from 'dashboard/forms/FormAddListItem/FormAddListItem';
import { COUNTRIES, CountryCode } from 'lib/constants/locales';

const ENABLED_COUNTRIES_OPTIONS = sortBy('label')(
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  Object.keys(COUNTRIES).map((countryCode: CountryCode) => ({
    value: countryCode,
    label: COUNTRIES[countryCode],
  })),
);

const CountryFields = ({ submitting }: InjectedFormProps<{}, FormAddListItemProps>) => {
  return (
    <>
      <Field
        component={ReactSelectField}
        name='countryCode'
        id='countryCode'
        disabled={submitting}
        placeholder='Country'
        portal
        options={ENABLED_COUNTRIES_OPTIONS}
      />
    </>
  );
};

export default CountryFields;
